export default "__VITE_ASSET__mCO4ctO3__"